import type { AnnouncementSeverity } from "@vital/shared";
import {
  announcementSeverityLabelFa,
  announcementSeverityTone,
} from "../lib/announcements-ops";
import { cmsStrings } from "../terminology";

type Props = {
  title: string;
  body: string;
  severity: AnnouncementSeverity;
  dismissible: boolean;
  emergency?: boolean;
};

export function AnnouncementPreview({
  title,
  body,
  severity,
  dismissible,
  emergency = false,
}: Props) {
  const tone = announcementSeverityTone(severity);
  const c = cmsStrings.announcementsComposer;

  return (
    <div className="login-preview" aria-label={c.previewAria}>
      <p className="login-preview__viewport">
        <bdi dir="ltr" className="ltr-isolate latin-digits">
          320px
        </bdi>
      </p>
      <div className="login-preview__device">
        <header className="login-preview__brand">
          <p className="login-preview__brand-en ltr-isolate" dir="ltr">
            {cmsStrings.brand.nameEn}
          </p>
          <p className="login-preview__tagline">{c.previewTagline}</p>
        </header>
        <div className="login-preview__card">
          <p className="login-preview__welcome">{c.previewWelcome}</p>
          <div
            className={`login-preview__banner login-preview__banner--${tone}${
              emergency ? " login-preview__banner--emergency" : ""
            }`}
            role="status"
          >
            <span className="login-preview__severity">
              {announcementSeverityLabelFa(severity)}
              {emergency ? ` · ${cmsStrings.inventory.emergencyBadge}` : ""}
            </span>
            <p className="login-preview__title">{title.trim() || c.previewEmptyTitle}</p>
            <p className="login-preview__body">{body.trim() || c.previewEmptyBody}</p>
            {dismissible && <span className="login-preview__dismiss">{c.close}</span>}
          </div>
          <div className="login-preview__fields" aria-hidden="true">
            <span className="login-preview__field-label">{c.previewUsername}</span>
            <span className="login-preview__field" />
            <span className="login-preview__field-label">{c.previewPassword}</span>
            <span className="login-preview__field" />
            <span className="login-preview__submit">{c.previewLoginSubmit}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
